import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';
import { getSponsorLogo, isAuthorized, Preloader } from "../../utils";
import _ from 'lodash';
// import MatchCentreControls from "./MatchCentreControls";
import MatchCentreInfoBar from "./MatchCentreInfoBar";
import MatchCentreHeading from "./MatchCentreHeading";
import MatchCentrePlayersPool from './MatchCentrePlayersPool';
import Radio from 'backbone.radio';
import Backbone, { Model } from "backbone";
import { User } from "../../models";
import { PlayerPopup } from "../Fantasy/Team/PlayerPopup";

const MATCH_CENTRE_CHANNEL = Radio.channel('match_centre');

export class MatchCentre extends View {
	get template() {
		return template;
	}

	get className() {
		return 'match-centre shadow';
	}

	regions() {
		return {
			controls: '.js-controls',
			info_bar: '.js-info-bar',
			heading: '.js-heading',
			pool: '.js-pool',
			ad_container: '.ad-container',
			popup: '.js-player-popup'
		}
	}
	childViewEvents() {
		return {
			'player:show:popup': 'onPlayerShowPopup',
		}
	}

	initialize() {
		this.liveScoresIntervalId = null;

		this.round_id = parseInt(this.getOption('round_id'), 10);
		this.match_id = parseInt(this.getOption('match_id'), 10);

		this.initListeners()
			.initLayouts()
			.requestData();
	}

	initListeners() {
		this.listenTo(this, 'main:data:requested', this.onMainDataRequested);
		this.listenTo(this, 'data:requested', this.onDataRequested);
		this.listenTo(this, 'live:data:requested', this.onLiveDataRequested);
		this.listenTo(MATCH_CENTRE_CHANNEL, 'controls:round:changed', this.changeRound);
		this.listenTo(MATCH_CENTRE_CHANNEL, 'controls:match:changed', this.changeMatch);

		return this;
	}

	initLayouts() {
		// this.initLayout('controls', new MatchCentreControls())
		this.initLayout('info_bar', new MatchCentreInfoBar())
			.initLayout('heading', new MatchCentreHeading())
			.initLayout('pool', new MatchCentrePlayersPool());


		return this;
	}

	initLayout(region, view) {
		if (!this.getRegion(region).hasView()) {
			this.showChildView(region, view);
		}

		return this;
	}

	get requestModels() {

		return _.pick(
			this.options,
			'squads', 'rounds', 'players',
			'team', 'coach',
			(isAuthorized() ? 'favourites' : null),
		)
	}

	async requestData() {
		Preloader.show();

		const requests = _.invokeMap(this.requestModels, 'fetch');

		await Promise.all(requests);

		this.trigger('main:data:requested');

		return this;
	}

	onMainDataRequested() {
		const
			actual_round = this.options.rounds.actual,
			last_round = this.options.rounds.last_round,
			next_round_id = this.options.rounds.next.get('id'),
			actual_round_id = actual_round.get('id'),
			last_round_id = last_round.get('id');
		this.model.set({
			next_round_id,
			actual_round_id,
			last_round_id,
		});
		this.setSelectedRound(this.round_id)
			.setMatches()
			.setMatchStatsId()
			.requestMatchStats()
	}

	onDataRequested() {
		this.checkRoundStatus()
			.updatePlayers()
			.initViews();
	}

	onLiveDataRequested() {
		this.setSelectedRound(this.round_id)
			.setMatches()
			.checkRoundStatus()
			.updatePlayers()
			.initViews();
	}

	setSelectedRound(id) {
		if (id) {
			this.selected_round = this.options.rounds.get(id);
		}
		else {
			this.selected_round = this.options.rounds.actual;
		}

		return this;
	}

	setMatches() {
		const { squads, rounds: rounds_collection } = this.options;
		const rounds = rounds_collection.toJSON();
		this.selected_round.setOpponents({ squads, match_id: this.match_id });
		const matches = this.selected_round.get('opponents'),
			selected_match = _.find(matches, match => match.is_selected )
		;

		this.selected_match = selected_match;
		this.match_id = _.result(selected_match, 'id');
		const selected_index = _.findIndex(matches, { id: selected_match.id });

		this.prev_match = this.getMatch(
			{ matches, selected_index, rounds, is_prev: true }
		);
		this.next_match = this.getMatch({ matches, selected_index, rounds, is_prev: false });

		return this;
	}

	getMatch({ matches, selected_index, rounds, is_prev }) {
		let match_id = false;
		const index = is_prev ? -1 : 1;

		if (matches[selected_index + index]) {
			match_id = matches[selected_index + index];
		}
		else {
			const previous_round = _.find(
				rounds, { id: this.selected_round.get('id') + index }
			);
			if (previous_round) {
				match_id = _.last(previous_round.matches);
			}
		}

		return match_id;
	}

	setSelectedMatchById(id) {
		const matches = this.selected_round.get('opponents');
		this.selected_match = _.find(matches, match => match.id === id );

		return this;
	}

	setMatchStatsId() {
		this.options.stats
			.setRoundId(this.selected_round.get('id'));

		return this;
	}

	async requestMatchStats() {
		this.options.stats.clear();

		await this.options.stats.fetch();

		this.trigger('data:requested');

		Preloader.hide();

		return this;

	}

	updatePlayers() {
		const
			rounds = this.options.rounds.toJSON(),
			round = this.selected_round,
			favourites = this.options.favourites.toJSON(),
			squads = this.options.squads.toJSON(),
			positions_by_id = this.options.positions.by_id,
			squad_by_id = _.keyBy(squads, 'id'),
			coach = User.has_assistant_coach ? this.options.coach.toJSON() : false,
			is_preseason = false,
			match_stats = this.options.stats.toJSON(),
			bye_rounds = this.options.rounds
				.filter(
					round => round.get('is_bye') && round.get('status')==='scheduled'
				).map(round => round.toJSON());

		this.options.players.each(player => {
			player
				.setPositionNames({ positions_by_id })
				.setSquadName({ squad_by_id })
				.setOpponent({ squad_by_id, round: round.toJSON() })
				.setCostChanges({ round_id: round.get('id') })
				.setStatsPointsLastRound({
					is_preseason, rounds,
					round_id: round.id,
					leader_id: null
				})
				.setFavourite(favourites)
				.setMatchStats({ match_stats, headings: this.options.stats.match_stats_headings });

			if (User.has_assistant_coach) {
				player
					.setCoachStats({
						coach,
						actual_round_id: this.model.get('actual_round_id'),
					})
					.setByRound({ bye_rounds });
			}
		});

		return this;
	}

	initViews() {
		// this.initControls()
		this.initInfoBar()
			.initHeadings()
			.initPlayers();

		return this;
	}

	initControls() {
		this.getChildView('controls').init({
			rounds: this.options.rounds.toJSON(),
			selected_round: this.selected_round.toJSON()
		});

		return this;
	}

	initInfoBar() {
		this.getChildView('info_bar').init({
			selected_match: this.selected_match,
			prev_match: this.prev_match,
			next_match: this.next_match
		});

		return this;
	}

	initHeadings() {
		this.getChildView('heading').init({
			headings: this.options.stats.match_stats_headings,
			selected_match: this.selected_match
		});

		return this;
	}

	initPlayers() {
		const is_actual_round = this.selected_round.id === this.options.rounds.actual.get('id');
		this.getChildView('pool').init({
			headings: this.options.stats.match_stats_headings,
			players: this.options.players,
			selected_match: this.selected_match,
			is_actual_round,
		});

		return this;
	}

	changeRound(id) {
		Preloader.show();
		this.match_id = null;

		this.setSelectedRound(parseInt(id, 10))
			.setMatches()
			.setMatchStatsId()
			.changeURL()
			.checkRoundStatus()
			.requestMatchStats();
	}
	changeMatch(selected_match_id) {
		Preloader.show();

		this.match_id = parseInt(selected_match_id, 10);

		this.setSelectedMatchById(this.match_id)
			.initInfoBar()
			.initPlayers()
			.changeURL()
			.checkRoundStatus();

		Preloader.hide();
	}

	changeURL() {
		const round_id = this.selected_round.get('id');

		let match_id = this.match_id,
			href = `/match-centre/${round_id}`;

		if (match_id) {
			href += `/${match_id}`;
		}

		Backbone.history.navigate(href);

		return this;
	}


	checkRoundStatus() {
		if (this.selected_round.is_active) {
			this.subscribeToLiveUpdates();
		}
		return this;
	}

	subscribeToLiveUpdates() {
		clearTimeout(this.liveScoresIntervalId);

		const { rounds, players, stats } = this.options;

		let time = this.selected_match.status === 'playing' ? 1 : 5;

		this.liveScoresIntervalId = setTimeout(async () => {
			const requests = _.invokeMap([rounds, players, stats], 'fetch');

			await Promise.all(requests);

			this.trigger('live:data:requested');
		}, time * 1000 * 60);

	}


	onPlayerShowPopup({ id }) {
		const
			player = this.options.players.get(parseInt(id, 10)).toJSON();

		if (!player) {
			return this;
		}

		const
			{
				actual_round_id,
				last_round_id,
				next_round_id,
			} = this.model.attributes,
			sponsor_logo = getSponsorLogo();

		this.showChildView('popup', this.getPlayerPopupView({
			...player,
			actual_round_id,
			last_round_id,
			next_round_id,
			has_assistant_coach: User.has_assistant_coach,
			sponsor_logo,
			rounds: this.options.rounds,
			is_from_field: false,
			bench_rank: undefined,
			is_unlimited_trades: undefined,
			is_from_bench: undefined,
			field_position: undefined,
			field_position_key: undefined,
			is_in_salary: undefined,
			is_locked: undefined
		}));
	}

	getPlayerPopupView(args) {
		return new PlayerPopup({
			model: new Model(args)
		})
	}
}

export default MatchCentre;